import React, { useState, useEffect, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import { useFirestore } from 'react-redux-firebase';
import { compose } from 'redux';
import { connect } from 'react-redux';
import M from 'materialize-css';
import { DatePicker } from 'react-materialize';
import { dateToYYYYMMDD, generateRangeDate } from '../../utils/DateUtil';
import { CSVLink } from 'react-csv';

function DownloadEntries(props) {
  const [fromDate, setFromDate] = useState(null);
  const [fromDay, setFromDay] = useState('');
  const [toDate, setToDate] = useState(null);
  const [toDay, setToDay] = useState('');
  const { contests = [] } = props;
  const [contestId, setContestId] = useState('');
  const [contest, setContest] = useState(null);
  const [contestEntries, setContestEntries] = useState([]);
  const [profileIds, setProfileIds] = useState(new Set());
  const [profiles, setProfiles] = useState(null);
  const firestore = useFirestore();
  const [fromHistory, setFromHistory] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const { auth } = props;

  useEffect(() => {
    var elems = document.querySelector('#contestSelect');
    M.FormSelect.init(elems);
  }, [contests]);

  useEffect(() => {
    if (profileIds.length === 0) return;

    var elems = document.querySelector('#collectionSelect');
    M.FormSelect.init(elems);

    loadProfilesByIds(profileIds, firestore);
  }, [profileIds, firestore]);

  const loadProfilesByIds = (profileIds, firestore) => {
    const promises = [...profileIds].map((id) => firestore.doc(`profiles/${id}`).get());

    Promise.all(promises).then((allRefs) => {
      const profiles = {};
      allRefs.forEach((doc) => {
        profiles[doc.id] = doc.data();
      });
      setProfiles(profiles);
    });
  };

  useEffect(() => {
    if (!profiles) return;

    const updatedEntries = [];
    setContestEntries((ce) => {
      for (const entry of ce) {
        const profile = profiles[entry.idUser];

        const ne = {
          ...entry,
          name: profile.name,
          lastName: profile.lastName,
          email: profile.email,
        };
        updatedEntries.push(ne);
      }
      return updatedEntries;
    });
  }, [profiles]);

  if (!auth.uid) return <Redirect to="/signin" />;

  const renderContestOption = (contest) => {
    return (
      <option key={contest.id} value={contest.id}>
        {`${contest.name} (${contest.countryCode})`}
      </option>
    );
  };

  const fieldValue = ({ field, value }) => {
    return (
      <Fragment>
        <b>{field}</b>: {value}
        <br />
      </Fragment>
    );
  };

  const selectedDate = ({ title, date }) => (
    <div className="row">
      <div className="col">{fieldValue({ field: title, value: date != null ? dateToYYYYMMDD(date) : null })}</div>
    </div>
  );

  const dateField = ({ id, title, onChange }) => {
    return (
      <Fragment>
        <span className="card-title">{title}</span>
        <DatePicker
          id={id}
          format="mmm dd, yyyy"
          onChange={(value) => {
            onChange(value);
            return false;
          }}
        />
        <div style={{ clear: 'both' }}></div>
        <br />
      </Fragment>
    );
  };

  const cardRangeDate = (actionText, actionClick) => {
    return (
      <Fragment>
        <div className="row">
          <div className="col l6 m6 s12">
            <div className="card">
              <div className="card-content">
                {dateField({
                  id: 'from_date',
                  title: 'From Date',
                  onChange: (value) => {
                    const date = new Date(value);
                    setFromDay(dateToYYYYMMDD(date));
                    setFromDate(date);
                  },
                })}
                {selectedDate({ title: 'From Day', date: fromDate })}
              </div>
            </div>
          </div>
          <div className="col l6 m6 s12">
            <div className="card">
              <div className="card-content">
                {dateField({
                  id: 'to_date',
                  title: 'To Date',
                  onChange: (value) => {
                    const date = new Date(value);
                    setToDay(dateToYYYYMMDD(date));
                    setToDate(date);
                  },
                })}
                {selectedDate({ title: 'To Day', date: toDate })}
              </div>
            </div>
          </div>
        </div>
        <button className="btn" onClick={actionClick}>
          {actionText}
        </button>
      </Fragment>
    );
  };

  const loadContestById = (contestId) => {
    firestore
      .collection('contests')
      .doc(contestId)
      .get()
      .then((doc) => setContest(doc.data()))
      .catch((e) => M.toast({ html: e.message }));
  };

  const renderContestsSelect = () => {
    return (
      <Fragment>
        <select
          id={'contestSelect'}
          value={contestId}
          onChange={(e) => {
            const contestId = e.target.value;
            setContestId(contestId);
            loadContestById(contestId);
          }}>
          <option value="" disabled>
            Choose a contest
          </option>
          {contests.map((contest) => renderContestOption(contest))}
        </select>
        <label>Contest</label>
      </Fragment>
    );
  };

  const renderCollectionSelect = () => {
    return (
      <>
        <select
          id={'collectionSelect'}
          value={'ENTRIES'}
          onChange={(e) => {
            const value = e.target.value;
            setFromHistory(value === 'HISTORY');
          }}>
          <option key="ENTRIES" value="ENTRIES">
            From Current Entries
          </option>
          <option key="HISTORY" value="HISTORY">
            From History
          </option>
        </select>
        <label>Source</label>
      </>
    );
  };

  const validateFields = () => {
    if (contestId && fromDay && toDay) return true;

    return false;
  };

  const loadEntries = async () => {
    if (!validateFields()) {
      M.toast({ html: 'Please fix ALL required fields' });
      return;
    }

    if (contestEntries.length > 0) {
      M.toast({ html: 'Entries already loaded, come back to generate for other contest' });
      return;
    }

    try {
      const querySnapshot = await firestore
        .collection(fromHistory ? 'contestEntriesHistory' : 'contestEntries')
        .where('idContest', '==', contestId)
        .where('day', '>=', fromDay)
        .where('day', '<=', toDay)
        .get();

      if (querySnapshot.size === 0) {
        setContestEntries([]);
        setProfileIds(new Set());
        setShowResults(true);
        return;
      }

      let profileIds = new Set();
      let contestEntries = [];
      let tempDocs = [];

      querySnapshot.forEach((doc) => {
        tempDocs.push({ id: doc.id, ...doc.data() });
      });

      for (const entry of tempDocs) {
        profileIds.add(entry.idUser);

        contestEntries.push({
          id: entry.id,
          day: entry.day,
          country: entry.countryCode,
          idUser: entry.idUser,
        });
      }

      setContestEntries(contestEntries);
      setProfileIds(profileIds);
      setShowResults(true);
    } catch (error) {
      M.toast({ html: error.message });
    }
  };

  const downloadEntries = () => {
    if (!contestEntries || contestEntries.length === 0) return <div></div>;

    return (
      <Fragment>
        <h5>Contest Entries Loaded:{contestEntries.length}</h5>
        <CSVLink filename={contest.name + '_' + Date.now() + '.csv'} className="waves-effect waves-light btn" target="_blank" data={contestEntries}>
          Download Entries
        </CSVLink>
      </Fragment>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Download Contests Entries</div>
      <div className="row">
        <div className="col l6 m6 s12">{renderContestsSelect()}</div>
        <div className="col l6 m6 s12">{renderCollectionSelect()}</div>
      </div>
      {cardRangeDate('Load Entries', loadEntries)}
      {contestEntries.length === 0 && showResults && (
        <div className="row">
          <b>No entry found.</b>
        </div>
      )}
      <div className="row">
        <div className="col l6 m6 s12">{downloadEntries()}</div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    contests: state.firestore.ordered.contests,
  };
};

export default compose(
  firestoreConnect([
    {
      collection: 'contests',
      orderBy: ['name', 'asc'],
    },
  ]),
  connect(mapStateToProps),
)(DownloadEntries);
